import React from "react";
import { inject, observer } from "mobx-react";
import { FormRow, InputError, Option, RadioGroup } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { FEEDBACK_TYPES } from "../../../utils/enums";
import { emptyError } from "../../../utils/commonUtils";

const FeedbackType = observer(({ FeedbackStore }) => {
  const key = "type";
  const { feedback, updateError, updateValue, updateIncluded } = FeedbackStore;
  const type = feedback.type;
  const msgs = useMessageGetter("feedback.form.type");

  updateIncluded(key, true);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (!type.value) updateError(key, emptyError(msgs));
  };

  return (
    <FormRow
      label={msgs("label")}
      labelFor={`CFF-${key}`}
      labelId={`cff-feedbackTypes`}
    >
      <RadioGroup
        id={`CFF-${key}`}
        name={key}
        value={type.value}
        onChange={(_e, val) => handleOnChange(val)}
        onBlur={() => handleOnBlur()}
        aria-required={true}
      >
        {FEEDBACK_TYPES.map((option) => (
          <Option
            id={`CFF-${key}-${option}`}
            key={option}
            value={option}
            aria-describedby={!!type.error ? `CFF-${key}-error` : null}
            invalid={!!type.error}
          >
            {msgs(`options.${option}`)}
          </Option>
        ))}
      </RadioGroup>
      <InputError
        id={`CFF-${key}-error`}
        error={type.error ? type.error : null}
      />
    </FormRow>
  );
});

export default inject("FeedbackStore")(FeedbackType);
